// src/utils/photoHelper.js
// Returns the correct headshot URL based on espn_type and espn_id.
// Drop this file into src/utils/ and import getPhotoUrl wherever you render player photos.

/**
 * @param {string} espn_id   - The ID or hash stored in the CSV espn_id column
 * @param {string} espn_type - 'player' | 'coach' | 'pfhof' | '' | undefined
 * @returns {string | null}  - Full image URL, or null if no ID
 */
// Right-size Supabase-hosted custom photos via Storage image transforms (enabled on
// the project): the stored 'custom' files are full-resolution (100KB-1MB) but display
// at 145px, so they used to pop in a beat after the name. Rewriting the public-object
// URL to the render endpoint + transform params serves ~5-40KB instead. Only touches
// Supabase public-object URLs; non-Supabase custom (e.g. Wikimedia) and already-render
// URLs pass through unchanged; idempotent.
const SB_OBJECT = '/storage/v1/object/public/';
const SB_RENDER = '/storage/v1/render/image/public/';
function toRightSizedCustom(url) {
  if (typeof url !== 'string') return url;
  if (!url.includes('supabase.co' + SB_OBJECT)) return url;
  if (url.includes(SB_RENDER)) return url;
  const sep = url.includes('?') ? '&' : '?';
  return url.replace(SB_OBJECT, SB_RENDER) + `${sep}width=200&height=145&resize=contain&quality=75`;
}

export function getPhotoUrl(espn_id, espn_type) {
  if (!espn_id || espn_id.trim() === '') return null;

  const type = espn_type?.trim() || 'player';

 switch (type) {
  case 'coach':
    return `https://a.espncdn.com/combiner/i?img=/i/headshots/nfl/coaches/full/${espn_id}.png&w=200&h=145&cb=1`;
  case 'pfhof':
    return `https://static.clubs.nfl.com/image/upload/w_200,h_145,c_fill,g_face,f_auto/hof/${espn_id}`;
  case 'custom':
    return toRightSizedCustom(espn_id);
  case 'player':
  default:
    return `https://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/${espn_id}.png&w=200&h=145&cb=1`;
  }  // ← closes switch
}    // ← closes getPhotoUrl function

export const SILHOUETTE_URL =
  'https://static.www.nfl.com/image/private/f_auto,q_auto/league/api/clubs/logos/nfl';
